/**
 * Created by mac on 7/23/25
 */

const HungryGamesMerge2Adapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("add", (mission) => {
            if (!Merge2.current || mission.getType() !== Mission.TYPE_HUNGRY_GAMES) {
                return;
            }

            if (mission.logic.state === HungryGamesLogic.STATES.ACTIVE) {
                const order = HungryGamesMerge2Adapter.addOrder();
                if (!order || order.getTimeLeft() <= 0) {
                    HungryGamesMerge2Adapter.removeOrder();
                    mission.logic.loseCompetition();
                }
            }
            cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
        });

        cleverapps.missionManager.on("complete", (mission) => {
            if (mission.getType() === Mission.TYPE_HUNGRY_GAMES) {
                HungryGamesMerge2Adapter.removeOrder();
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("hungryGamesStart", (mission) => {
            if (mission.getType() === Mission.TYPE_HUNGRY_GAMES && mission.isRunning()) {
                mission.logic.startCompetition();

                const order = HungryGamesMerge2Adapter.addOrder();
                if (order) {
                    order.onTimeExpiredCallback = function () {
                        mission.logic.loseCompetition();
                    };
                    order.startLevel();
                    order.assignOrder(mission.result);
                }
            }
        });

        cleverapps.missionManager.on("hungryGamesLose", (mission) => {
            if (mission.getType() === Mission.TYPE_HUNGRY_GAMES) {
                HungryGamesMerge2Adapter.logPlayedTime(mission, Mission.EVENTS.MISSION_LOSE_TIME, mission.result + 1);

                if (mission.logic.state === HungryGamesLogic.STATES.LOST) {
                    mission.logic.showLoseWindow();
                }
            }
        });

        cleverapps.missionManager.on("hungryGamesWin", (mission) => {
            if (mission.getType() === Mission.TYPE_HUNGRY_GAMES) {
                HungryGamesMerge2Adapter.logPlayedTime(mission, Mission.EVENTS.MISSION_WIN_TIME, HungryGamesLogic.LEVELS_AMOUNT);
            }
        });

        cleverapps.missionManager.on("hungryGamesLevelAdvanced", (mission) => {
            if (mission.getType() !== Mission.TYPE_HUNGRY_GAMES) {
                return;
            }

            cleverapps.timeouts.setTimeout(() => {
                if (mission.logic.previousLevel === undefined) {
                    return;
                }

                if (cleverapps.focusManager.isFocused()) {
                    mission.logic.needShowAdvanceWindow = true;
                } else {
                    mission.logic.showAdvanceWindow();
                }
            }, 2000);
        });

        cleverapps.missionManager.on("hungryGamesRemoveOrder", (mission) => {
            if (mission.getType() === Mission.TYPE_HUNGRY_GAMES) {
                HungryGamesMerge2Adapter.removeOrder();
            }
        });

        cleverapps.missionManager.on("hungryGamesStartNextOrder", (mission) => {
            if (mission.getType() !== Mission.TYPE_HUNGRY_GAMES || !mission.isRunning() || mission.logic.state !== HungryGamesLogic.STATES.ACTIVE) {
                return;
            }

            const order = HungryGamesMerge2Adapter.addOrder();
            if (order) {
                order.onTimeExpiredCallback = mission.logic.loseCompetition.bind(mission.logic);
                order.startLevel();
                order.assignOrder(mission.result);
            }
        });

        cleverapps.eventBus.on("complete_order", () => {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_HUNGRY_GAMES);
            if (!mission || mission.logic.state !== HungryGamesLogic.STATES.ACTIVE) {
                return;
            }

            const order = HungryGamesMerge2Adapter.getOrder();
            if (order && !order.customer.recipe) {
                mission.logic.logEvent(Mission.EVENTS.MISSION_STAGE_TIME, { value: Math.round((Date.now() - order.levelStartTime) / 1000) });
                order.clearLevelTimeout();
            }
        });

        cleverapps.eventBus.on("customersRestored", () => {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_HUNGRY_GAMES);
            if (!mission || mission.logic.state !== HungryGamesLogic.STATES.ACTIVE) {
                HungryGamesMerge2Adapter.removeOrder();
                return;
            }

            const order = HungryGamesMerge2Adapter.addOrder();
            if (!order || order.getTimeLeft() <= 0) {
                HungryGamesMerge2Adapter.removeOrder();
                mission.logic.loseCompetition();
            } else {
                order.onTimeExpiredCallback = function () {
                    mission.logic.loseCompetition();
                };
                order.startLevelTimeout();
                order.assignOrder(mission.result);
            }
        });
    },

    logPlayedTime: function (mission, event, stages) {
        const playedTime = Math.max(0, Math.min(Date.now() - mission.logic.competitionStart, stages * HungryGamesOrder.LEVEL_DURATION));
        mission.logic.logEvent(event, { value: Math.round(playedTime / 1000) });
    },

    getOrder: function () {
        if (!Merge2.current || !Merge2.current.customers) {
            return;
        }
        const customer = Merge2.current.customers.findEventCustomer();
        return customer && customer.eventOrder;
    },

    addOrder: function () {
        const order = HungryGamesMerge2Adapter.getOrder();
        if (order) {
            return order;
        }

        if (!Merge2.current || !Merge2.current.customers) {
            return;
        }

        const customer = Merge2.current.customers.findEventCustomer();
        if (!customer) {
            return;
        }

        return new HungryGamesOrder(customer);
    },

    removeOrder: function () {
        const order = HungryGamesMerge2Adapter.getOrder();
        if (order) {
            order.removeOrder();
            return;
        }

        cleverapps.dataLoader.remove(DataLoader.TYPES.HUNGRY_GAMES_MERGE2);

        if (!Merge2.current || !Merge2.current.customers) {
            return;
        }

        const customer = Merge2.current.customers.findEventCustomer();
        if (customer && customer.recipe) {
            customer.recipe = undefined;
            customer.reward = undefined;
            customer.expReward = undefined;
            customer.raveReviewReward = undefined;

            Merge2.current.customers.save();
        }
    }
};

cleverapps.whenAllInitialized(() => {
    HungryGamesMerge2Adapter.SubscribeToEvents();
});
